import React from "react";
import {KeepPlayingDelaySelector} from "../KeepPlayingDelaySelector/KeepPlayingDelaySelector";
import SwitchButton from "../SwitchButton/SwitchButton";
import styles from "./KeepPlayingOptions.module.css";
import {Label} from "../Label/Label";

export const KeepPlayingOptions = ({delay, autoPlayEnabled= true, onPlayOptionsChange, className}) => {
    return (
        <div className={`${className} ${styles.container}`}>
            <div className={styles.switchContainer}>
                <Label>Auto Play</Label>
                <SwitchButton checked={autoPlayEnabled} onToggle={(checked)=> onPlayOptionsChange(delay, checked)}/>
            </div>
            <KeepPlayingDelaySelector delay={delay} setDelay={(newDelay)=> onPlayOptionsChange(newDelay, autoPlayEnabled)} enabled={autoPlayEnabled}/>
        </div>
    )
}